<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="form-group" v-for="header in table_columns_rms">
        <label for=""> {{capitalize(header.name)}}</label>
        <input type="text" class="form-control" :value="selectedProduct[header.name]" disabled>
      </div>
    </div>

  </div>
</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  props: ['product'],
  data: function () {
    return {
      selectedProduct: '',
      product_rms: '',
      table_columns_rms: []
    }
  },
  methods: {
    getRMSData: function () {
      var self = this
      const url = '/reportdesk/report/rms'
      var data = {
        id_product: self.product.id_product
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data.products.data[0]

          self.formatRMSColumns(self.selectedProduct)
        })
        .catch(function (error) {})
    },
    formatRMSColumns (product) {
      var self = this
      let keys = []
      Object.keys(product).forEach(function (item) {
        keys.push({
          name: item,
          rowspan: 2,
          class: '',
          visible: true
        })
        // self.product_columns.push(item);
      })
      this.table_columns_rms = keys
    }
  },
  watch: {
    product () {
      this.getRMSData()
    }
  }
}
</script>

<style scoped>
</style>
